import {
  useMutation
} from '@tanstack/react-query'
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query'
import type {
  AddConversationMessage200,
  AddConversationMessage400,
  AddConversationMessage401,
  AddConversationMessage404,
  AddConversationMessageBody
} from './types'
import { customInstance } from '../custom-axios';


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * 스트리밍 외부에서 수집한 메시지를 대화 기록에 추가합니다.
 * @summary 대화 메시지 저장
 */
export const addConversationMessage = (
    conversationId: string,
    addConversationMessageBody: AddConversationMessageBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<AddConversationMessage200>(
      {url: `https://ai.ugot.uk/api/ai/conversations/${conversationId}/messages`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addConversationMessageBody
    },
      options);
    }
  


export const getAddConversationMessageMutationOptions = <TError = AddConversationMessage400 | AddConversationMessage401 | AddConversationMessage404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addConversationMessage>>, TError,{conversationId: string;data: AddConversationMessageBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof addConversationMessage>>, TError,{conversationId: string;data: AddConversationMessageBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addConversationMessage>>, {conversationId: string;data: AddConversationMessageBody}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  addConversationMessage(conversationId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddConversationMessageMutationResult = NonNullable<Awaited<ReturnType<typeof addConversationMessage>>>
    export type AddConversationMessageMutationBody = AddConversationMessageBody
    export type AddConversationMessageMutationError = AddConversationMessage400 | AddConversationMessage401 | AddConversationMessage404

    /**
 * @summary 대화 메시지 저장
 */
export const useAddConversationMessage = <TError = AddConversationMessage400 | AddConversationMessage401 | AddConversationMessage404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addConversationMessage>>, TError,{conversationId: string;data: AddConversationMessageBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof addConversationMessage>>,
        TError,
        {conversationId: string;data: AddConversationMessageBody},
        TContext
      > => {

      const mutationOptions = getAddConversationMessageMutationOptions(options);

      return useMutation(mutationOptions);
    }
    